
import { FirebaseAuthGoogle, watchUser } from '../../firebase/common/firebaseAuthGoogle';
import { getAuth } from "firebase/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from 'primereact/button';
import react, { useState, useEffect } from 'react';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { selectAuth, login, logout } from '../authSlice';

export function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    // Returns the intended destination after login or falls back to the default route.
    const getReturnToPath = () => {
        if (location.state?.from) {
            return location.state.from;
        }
        const params = new URLSearchParams(location.search);
        return params.get('returnTo') || '/favorites';
    };

    // Updates auth state and navigates to the intended destination after login.
    const loginCallBack = (user) => {
        //console.log(user)
        dispatch(login(
            {
                displayName: user.displayName,
                isLogged: false,
                uid: user.uid,
                email: user.email,
                photoURL: user.photoURL
            }));
        navigate(getReturnToPath());
    }

    useEffect(() => watchUser(loginCallBack, null), []);

    // Triggers the Google login popup.
    const registerClick = () => FirebaseAuthGoogle();

    return <div className='flex p-5 justify-content-center'>

        <Button onClick={registerClick} label="Login with Google!"></Button>

    </div>;

}
